import { atom } from 'recoil'
import { Unidade } from '@/domain/models'

export const unitsState = atom({
  key: 'unitsState',
  default: [] as Unidade[]
})
